export const AUTH_PATHS = ['/login', '/signup', '/reset', '/reset-password'] as const;
export type AuthPath = (typeof AUTH_PATHS)[number];

export function authPathOf(pathname: string): AuthPath | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  return (AUTH_PATHS as readonly string[]).includes(path) ? (path as AuthPath) : null;
}

/** Where to go after signing in: only same-site paths, never back to an auth screen. */
export function safeNext(value: string | null): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return '/';
  const base = 'http://same-site.invalid';
  let url: URL;
  try { url = new URL(value, base); } catch { return '/'; }
  if (url.origin !== base || authPathOf(url.pathname)) return '/';
  return value;
}

export function recoveryToken(hash: string): string | null {
  return new URLSearchParams(hash.replace(/^#/, '')).get('access_token') || null;
}
